module.exports = __webpack_public_path__ + "static/img/bg.92ff618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20240302/bg.png
// module id = FSbl
// module chunks = 1